import { Stack } from "@mui/material";
import React, { useMemo } from "react";
import { useTheme } from "styled-components";
import { ReportType } from "../../abstract/Report";
import InfoRow from "../../components/InfoRow";
import { useReport } from "../../contexts/ReportContext";
import { useApp } from "../../contexts/AppContext";

interface PatientInfoCardProps {
  type: ReportType;
  notes?: string;
  patientInfo: {
    name: string;
    weight: string;
    age: string;
    ethnicity: string;
    height: string;
    amh: string | null;
  };
}

const labelWidth = 220;

const PatientInfoCard: React.FC<PatientInfoCardProps> = ({
  type,
  patientInfo,
  notes
}) => {
  const theme = useTheme();
  const { colorStyle } = useReport();

  const { translate } = useApp();
  const translations = useMemo(() => translate("eggfreeze"), [translate]);
  
  return (
    <Stack
      sx={
        type === "report"
          ? {
              backgroundColor:
                theme.palette.reportColorStyles[colorStyle].light,
              borderRadius: 4,
              padding: 2,
            }
          : {}
      }
      direction="row"
      justifyContent="space-between"
      alignItems="flex-start"
    >
      <Stack direction="row" spacing={12} alignItems="flex-start">
        <Stack spacing={2} maxWidth={320}>
          <InfoRow
            labelWidth={labelWidth}
            label={translations.report.patientInfo.name}
            value={patientInfo.name}
          />
          <InfoRow
            labelWidth={labelWidth}
            label={translations.report.patientInfo.weight}
            value={patientInfo.weight}
          />
          <InfoRow
            labelWidth={labelWidth}
            label={translations.report.patientInfo.age}
            value={patientInfo.age}
          />
        </Stack>
        <Stack spacing={2} maxWidth={320}>
          {patientInfo.ethnicity.length > 0 && (
            <InfoRow
              labelWidth={labelWidth}
              label={translations.report.patientInfo.ethnicity}
              value={patientInfo.ethnicity}
            />
          )}
          <InfoRow
            labelWidth={labelWidth}
            label={translations.report.patientInfo.height}
            value={patientInfo.height}
          />
          {patientInfo.amh && (
            <InfoRow
              labelWidth={labelWidth}
              label={translations.report.patientInfo.amh}
              value={patientInfo.amh}
            />
          )}
           {notes && (
            <InfoRow
              labelWidth={labelWidth}
              label={translations.report.patientInfo.notes}
              value={notes}
            />
          )}
        </Stack>
      </Stack>
    </Stack>
  );
};

export default PatientInfoCard;
